<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">UM PP Financial Report Manifest</h4>
              <small>{{ data.header.no_lk }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifest"
                    @click="handlePrint"
                    class="m-display-block"
                    >UMPP Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc
                ">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestkomisi"
                    @click="handlePrintKomisi"
                    class="m-display-block"
                    >Commision Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc
                ">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestfiktif"
                    @click="handlePrintFiktif"
                    class="m-display-block"
                    >Fictitious Name Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestWtNote"
                    @click="handlePrintWtNote"
                    class="m-display-block"
                    >Approval Commision Report</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <a-button
                    :disabled="
                      !(
                        data.last_status == 'Revised' &&
                        getAuth.username == data.user_pembuat.tlc
                      )
                    "
                    @click="handleEdit"
                    type="dashed"
                    size="small"
                    icon="edit"
                    block
                    class="m-display-block"
                    >Edit</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No UM PP</span>
                  <span class="m-list-desc">{{ data.header.no_um }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tanggal_buat).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total UM</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_um)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Amount of Use</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_pemakaian)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Remaining Balance</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_sisa_saldo)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{
                    data.isparsial=='1' ? "PARSIAL" : "FINAL"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.catatan ? data.header.catatan : '-'
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel v-if="getScreen" key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_invoice"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-spin :spinning="pageLoading">
                    <a-list-item-meta>
                      <span slot="title">{{
                        item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                      }}</span>
                      <div slot="description" class="margin-remove">
                        <span>{{
                          moment(item.tanggal).format(getDefaultDateFormat)
                        }}</span>
                        <div>
                          <span>{{ item.label }}</span>
                          <h4 class="margin-remove">
                            {{ formatCurrency(data.mata_uang, item.nilai) }}
                          </h4>
                        </div>
                        <a-button-group v-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                          <a-button type="primary" icon="edit" @click="handleUploadDoc(item)"></a-button>
                          <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                          <a-button type="default" disabled v-else>No File</a-button>
                        </a-button-group>
                        <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                          View Document
                        </a>
                        <div v-else class="margin-top">
                          :: No File Uploaded ::
                        </div>
                      </div>
                    </a-list-item-meta>
                  </a-spin>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
            <a-collapse-panel v-if="!getScreen" key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="deskripsi" slot-scope="item">
                  {{ item.deskripsi }}<br />
                  <b>{{ item.nm_um }}</b
                  ><br />
                </span>
                <template slot="document" slot-scope="index, item">
                  <span v-if="item.deskripsi.toLowerCase() == 'terima uang muka'"></span>
                  <a-button-group v-else-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                    <a-button type="primary" icon="edit" @click="handleUploadDoc(item)" :loading="uploadDoc.loading2 && uploadDoc.loading2key == item.id_dtl"></a-button>
                    <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                    <a-button type="default" disabled v-else>No File</a-button>
                  </a-button-group>
                  <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                    View Document
                  </a>
                  <span v-else>
                    No File Uploaded
                  </span>
                </template>
                <span slot="debit" slot-scope="debit">
                  <CurrencyJustified
                    v-if="debit.val"
                    :currencyValue="debit.curr"
                    :valueNumber="debit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit.val"
                    :currencyValue="kredit.curr"
                    :valueNumber="kredit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="sisa" slot-scope="sisa">
                  <CurrencyJustified
                    :currencyValue="sisa.curr"
                    :valueNumber="sisa.val"
                  />
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total UM</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="Number(data.header.total_um)"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Amount of Use</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="Number(data.header.total_pemakaian)"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Remaining Balance</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="Number(data.header.total_sisa_saldo)"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse>

          <template v-if="!getScreen">
            <a-alert
              v-if="
                data.jenis.toLowerCase() == 'close' &&
                data.status_close.toLowerCase() !== 'true'
              "
              class="margin-top"
              message="Process Cash-in at BKM first"
              banner
            />
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-else-if="
                (data.jenis.toLowerCase() !== 'manifest' &&
                  data.jenis.toLowerCase() !== 'transfer') ||
                (data.jenis.toLowerCase() == 'close' &&
                  data.status_close.toLowerCase() == 'true')
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi" v-if="data.aksi">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() === 'transfer' && data.status_transfer
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Aksi" v-if="data.aksi">
                  <a-select
                    @change="changeAction"
                    showSearch
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: 'Transferred',
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="Transfer Date"
                  v-if="(aksiSelected === 'Transferred'|| 
                    aksiSelected === 'Upload BA') || aksiSelected === ''"
                >
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>
                
                <a-form-item
                 :label="aksiSelected === 'Upload BA' ? 'Document BA' :'Evidence of Transfer'"
                  v-if="(aksiSelected === 'Transferred'|| 
                    aksiSelected === 'Upload BA') || aksiSelected === ''"
                >
                  <a-upload
                    accept="image/*"
                    :showUploadList="true"
                    :fileList="push"
                    listType="picture"
                    :beforeUpload="beforeUpload"
                    :remove="handleRemoveList"
                    v-decorator="[
                      'upload',
                      { rules: [{ required: true }] },
                      { valuePropName: 'push' },
                    ]"
                  >
                    <a-button>
                      <a-icon type="upload" />&nbsp;Select File
                    </a-button>
                  </a-upload>
                </a-form-item>
                <a-form-item
                  label="Transfer Value"
                  v-if="(aksiSelected === 'Transferred'|| 
                    aksiSelected === 'Upload BA') || aksiSelected === ''"
                >
                  <a-input-number
                    :disabled="disabled"
                    type="number"
                    :max="data.sisa_tf"
                    class="m-width-full m-text-align right"
                    v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: data.sisa_tf,
                      },
                    ]"
                  />
                </a-form-item>
                <a-checkbox
                  v-if="(aksiSelected === 'Transferred' || 
                    aksiSelected === 'Upload BA') || aksiSelected === ''"
                  class="margin-bottom"
                  @change="handleCheckData"
                  :checked="checkTransferValue"
                  :disabled="aksiSelected === 'Upload BA'"
                  >The transferred value matches the remaining
                  balance</a-checkbox
                >
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    :disabled="aksiSelected === 'Upload BA'"
                    v-decorator="['remark']"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
          </template>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">{{data.last_status=='Upload BA' ? 'Document BA' : 'Evidence of Transfer'}}</div>
            <div>
              <a-alert
                v-if="data.bukti_transfer.length <= 0"
                type="error"
                message="No evidence of transfer was uploaded"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.bukti_transfer"
                v-else
              >
                <Empty
                  v-if="
                    data.bukti_transfer
                      ? data.bukti_transfer.length <= 0
                      : data.bukti_transfer
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">
                        {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                      </h3>

                      <a-button
                        @click="handleViewDt(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                      <h4 class="margin-remove" 
                      v-if="data.last_status!='Upload BA'"                   
                      >
                        {{ formatCurrency(data.mata_uang, item.value_tf) }}
                      </h4>
                    </div>
                    <img
                      class="m-image-icon"
                      slot="avatar"
                      :src="$serviceUrl + item.url"
                    />\
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-spin :spinning="pageLoading">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.user_pembuat.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(data.user_pembuat.tanggal).format(
                            getDefaultDateFormat
                          )
                        }}
                      </h4>
                      <span
                        class="m-text-small"
                        v-if="data.user_pembuat.catatan"
                        >{{ data.user_pembuat.catatan }}</span
                      >
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">{{
                        data.user_pembuat.status
                      }}</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                    :color="
                      workflow.status === 'On Process' ||
                      workflow.status === 'Delivered'
                        ? 'red'
                        : workflow.status === 'Waiting'
                        ? 'grey'
                        : 'green'
                    "
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor ? workflow.actor : workflow.job_desc }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(
                            getDateTimeFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-spin>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{
                        formatCurrency(data.mata_uang, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="getScreen">
            <a-alert
              v-if="
                data.jenis.toLowerCase() == 'close' &&
                data.status_close.toLowerCase() !== 'true'
              "
              class="margin-top"
              message="Process Cash-in at BKM first"
              banner
            />
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-else-if="
                (data.jenis.toLowerCase() !== 'manifest' &&
                  data.jenis.toLowerCase() !== 'transfer') ||
                (data.jenis.toLowerCase() == 'close' &&
                  data.status_close.toLowerCase() == 'true')
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() === 'transfer' && data.status_transfer
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    @change="changeAction"
                    v-decorator="['status', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="Transfer Date"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                >
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>
                <a-form-item
                  label="Evidence of Transfer"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                >
                  <a-upload
                    accept="image/*"
                    :showUploadList="true"
                    :fileList="push"
                    :remove="handleRemoveList"
                    listType="picture"
                    :beforeUpload="beforeUpload"
                    v-decorator="[
                      'upload',
                      { rules: [{ required: true }] },
                      { valuePropName: 'push' },
                    ]"
                  >
                    <a-button>
                      <a-icon type="upload" />&nbsp;Select File
                    </a-button>
                  </a-upload>
                </a-form-item>
                <a-form-item
                  label="Transfer Value"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                >
                  <a-input-number
                    :disabled="disabled"
                    type="number"
                    :max="data.sisa_tf"
                    class="m-width-full m-text-align right"
                    v-decorator="[
                      'value_transferan',
                      { rules: [{ required: true }] },
                    ]"
                  />
                </a-form-item>
                <a-checkbox
                  v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  class="margin-bottom"
                  @change="handleCheckData"
                  :checked="checkTransferValue"
                  >The transferred value matches the remaining
                  balance</a-checkbox
                >
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['remark']"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
          </template>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <b>Tanggal</b>
          </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
            <a-input v-model="uploadDoc.tanggal" disabled></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Description</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
            </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Transaction Document</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-upload
                :showUploadList="true"
                :fileList="uploadDoc.doctransfiles"
                :beforeUpload="beforedoctransUpload"
                v-model="uploadDoc.file"
                :disabled="uploadDoc.loading"
              >
              <!-- :remove="handledoctransRemove" -->
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-col>
        </a-row>
      </a-spin> 
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment, { localeData } from "moment";

export default {
  name: "ManifestLaporanUmpp",
  components: { "m-anim": lottie, Status },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: false,
      disabled: true,
      data: {
        header: {},
        jenis: "",
        last_status: null,
        user_pembuat: {},
        sisa_tf: null,
        aksi: null,
        bukti_transfer: [],
        detail_invoice: [],
        dokumen_terkait: [],
        status: [],
        history: [],
        mata_uang: "",
      },
      push: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      aksiSelected: "",
      checkTransferValue: true,
      printLoad:{
        manifest:false,
        manifestkomisi:false,
        manifestfiktif: false,
        manifestWtNote: false,
      },
      visibleUploadDoc: false,
      uploadDoc: {
        file: null,
        doctransfiles: null,
        id_dtl_trans: null,
        tanggal: null,
        deskripsi: null,
        loading: false,
        loading2: false,
        loading2key: "",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no.length - b.no.length,
          footer: (data) => {
            return "<div>Summary</div>";
          },
        },
        {
          title: "Tanggal",
          dataIndex: "tanggal",
          width: 100,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          width: 200,
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
          scopedSlots: { customRender: "deskripsi" },
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 125,
          align: "center"
        },
        {
          title: "Debit",
          dataIndex: "debit",
          key: "debit",
          width: 100,
          sorter: (a, b) => a.debit.length - b.debit.length,
          scopedSlots: { customRender: "debit" },
        },
        {
          title: "Kredit",
          dataIndex: "kredit",
          key: "kredit",
          width: 100,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
          scopedSlots: { customRender: "kredit" },
        },
        {
          title: "Saldo",
          dataIndex: "sisa",
          key: "sisa",
          width: 100,
          sorter: (a, b) => a.sisa.length - b.sisa.length,
          scopedSlots: { customRender: "sisa" },
        },
      ];
      return kolom;
    },
    searching() {
      if (this.search) {
        this.tableData = this.tableDataTemp;
        this.tableData = this.tableData.filter(
          (obj) =>
            (obj.deskripsi && obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0) ||
            moment(obj.tanggal, "DD-MM-YYYY")
              .format("DD-MM-YYYY")
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.nm_um && obj.nm_um.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  methods: {
    moment,
    async fetchManifest() {
      this.pageLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header: {
              no_lk: response.data.invoice[0].no_lk,
              no_um: response.data.invoice[0].no_um,
              tanggal_buat: response.data.invoice[0].tgl_buat,
              total_um: response.data.invoice[0].total_um_1 || 0,
              total_pemakaian: response.data.invoice[0].total_pemakaian_1 || 0,
              total_sisa_saldo:
                response.data.invoice[0].total_sisa_saldo_1 || 0,
              catatan: response.data.invoice[0].catatan,
            },
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tgl_buat,
              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            dokumen_terkait: response.data.dokumen_terkait,
            status: response.data.status_app,
            status_close: response.data.status_close,
            history: response.data.notifikasi,
            mata_uang: response.data.invoice[0].currency,
            status_transfer: response.data.status_transfer,
            isparsial: response.data.isparsial,
            iskomisi: response.data.iskomisi,
          };
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.data = {};
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/cetak_laporan_um_pp",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlePrintKomisi() {
      this.printLoad.manifestkomisi = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/cetak_laporan_um_pp_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestkomisi = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestkomisi = false;
          this.$router.go(-1);
        });
    },
    handlePrintFiktif() {
      this.printLoad.manifestfiktif = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/cetak_laporan_um_pp_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
          fiktif:"1",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestfiktif = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestfiktif = false;
          this.$router.go(-1);
        });
    },
    handlePrintWtNote() {
      this.printLoad.manifestWtNote = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/cetak_laporan_um_pp_tanpa_nota",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestWtNote = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestWtNote = false;
          this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "lapUmppEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          let post = new FormData();
          if (this.aksiSelected === "Revised") {
            post.append("status", values.status);
            post.append("remark", values.remark);
            post.append("tlc", this.getAuth.username);
            post.append("id_lk", this.id);
          } else {
            post.append("id_lk", this.id);
            post.append("tlc", this.getAuth.username);
            post.append("status", values.status);
            post.append("remark", values.remark);
            post.append(
              "tgl_tf",
              values.tgl_trf.format(this.getStandartFormatDate)
            );
            post.append("value_transferan", values.value_transferan);
            post.append("file_transfer", this.push[0]);
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "lap_um_pp/approval ",
            processData: false,
            data: post,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "lap_um_pp/approval ",
            processData: false,
            data: {
              id_lk: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: 0,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDt(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    getDetailPemakaianWeb() {
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/web_detil_pemakaian",
        params: {
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let dataPemakaian = response.data.detail_pemakaian;

          response.data.detail_pemakaian.forEach((value, index) => {
            if (value.debit !== "-") {
              dataPemakaian[index]["debit"] = {
                curr: value.currency,
                val: Number(value.debit),
              };
            }

            if (value.kredit !== "-") {
              dataPemakaian[index]["kredit"] = {
                curr: value.currency,
                val: Number(value.kredit),
              };
            }
            dataPemakaian[index]["sisa"] = {
              curr: value.currency,
              val: Number(value.sisa),
            };
            dataPemakaian[index]["tanggal"] = moment(value.tanggal).format(
              this.getDefaultDateFormat
            );

            dataPemakaian[index]["nm_um"] = value.nm_um;
          });

          this.tableData = dataPemakaian;
          this.tableDataTemp = dataPemakaian;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    changeAction(item) {
      this.aksiSelected = item;

        this.$nextTick(function () {
          this.form.setFieldsValue({
            remark: this.aksiSelected == 'Upload BA' ? 'Upload Berita Acara Penyelesaian Uang Muka' : '',
          });
        });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleUploadDoc(item) {
      this.uploadDoc.tanggal = item.tanggal;
      this.uploadDoc.deskripsi = item.deskripsi;
      this.uploadDoc.id_dtl_trans = item.id_dtl;

      this.uploadDoc.doctransfiles = [];

      if (item.lampiran) {
        this.uploadDoc.loading2 = true;
        this.uploadDoc.loading2key = item.id_dtl;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
          .then((response) => {
            let typefile = this.fileTypeFromUrl(item.lampiran);
            let file = this.dataURLtoFile(
              typefile + response.file_document_tax,
              item.lampiran
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + item.lampiran_path;
            this.uploadDoc.doctransfiles = [];
            this.uploadDoc.doctransfiles.push(file);

            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            this.visibleUploadDoc = true;
          })
          .catch((err) => {
            this.uploadDoc.loading2 = false;
            this.uploadDoc.loading2key = "";
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.visibleUploadDoc = true;
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let data = new FormData();
        data.append("tipe_trans", "lap_um_pp");
        data.append("id_dtl_trans", this.uploadDoc.id_dtl_trans);
        data.append("file_upload", file);

        this.uploadDoc.loading = true;
        this.asyncAxiosPost("main/upload_lampiran", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.uploadDoc.loading = false;
            this.getDetailPemakaianWeb();
            this.visibleUploadDoc = false;
        })
        .catch((err) => {
          console.log(err);
          this.uploadDoc.loading = false;
          if (err.response && err.response.data) {
            this.$notification.error({
              message: "Error Message",
              description: err.response.data.message,
            });
          } else {
             let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
          }
        });
        this.uploadDoc.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.uploadDoc.doctransfiles = [];
    },
  },
  created() {
    this.fetchManifest();
    if (!this.getScreen) {
      this.getDetailPemakaianWeb();
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = false;
        this.search = "";
      }

      if (!this.getScreen) {
        this.getDetailPemakaianWeb();
      }
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}
</style>
